/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { NotificationSchemaMetadataJson } from './notificationSchemaMetadataJson';

export interface NotificationSchema {
  id: string;
  user_id: string;
  org_id: string;
  category: string;
  title: string;
  body?: string | null;
  actor_user_id?: string | null;
  target_kind?: string | null;
  target_id?: string | null;
  target_url?: string | null;
  metadata_json?: NotificationSchemaMetadataJson;
  event_dedup_key?: string | null;
  attempt: number;
  read_at?: string | null;
  cleared_at?: string | null;
  created_at: string;
}
